// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
import { AuthGuard } from './core/auth';
import { CusWebpageauthGuard } from './core/auth/_guards/cuswebpageauth.guard';
const routes: Routes = [
	{
		path:'auth', loadChildren: () => import('./views/pages/auth/auth.module').then(m => m.AuthModule)},
		//   {
		// 	path: '',
		// 	redirectTo: 'customer/webform', 
		// 	pathMatch: 'full',

		// },
		//   { 
		// 	path : 'customer/unregister', 
		// 	component : CusUnregisteredComponent, 
		// 	canActivate:[CusWebpageauthGuard],
		//   },
		//   { 
		// 	path : 'customer/register', 
		// 	component : CusRegisteredComponent,
		// 	canActivate:[CusWebpageauthGuard],
		//   },
	
 // Customer (lazy loaded)
  {
    path: 'customer',
    loadChildren: () =>
      import('./views/pages/customer/customer.module')
        .then(m => m.CustomerModule)
  },

  // Default landing
  {
    path: '',
    redirectTo: 'customer',
    pathMatch: 'full'
  },
{
		path: '',
		component: BaseComponent,
		canActivate: [AuthGuard],
		children: [
			{
			    path:'all', loadChildren: () => import('./views/pages/all-shared/all-shared.module').then(m => m.AllSharedModule)
			},
				{
				path: 'error/403',
				component: ErrorPageComponent,
				data: {
					'type': 'error-v6',
					'code': 403,
					'title': '403... Access forbidden',
					'desc': 'Looks like you don\'t have permission to access for requested page.<br> Please, contact administrator'
				}
			},

		]
	},
	

];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
